@if (!isMobile) {
  <div class="desktop-view">
    @if (isShowError()) {
      <section class="container noentry-info">
        <h3 class="noentry-title">No entry found</h3>
        <p class="progress-suggestions suggest">Suggestions:</p>
        <ul class="noentry-info msg_bullets">
          <li>Check the spelling.</li>
          <li>Try searching with a protein or gene name rather than by a specific accession.</li>
          <li>
            Check whether your protein may be excluded for one of the reasons outlined in our <a class="faqlink" href="/faq">FAQs</a>.</li>
          </ul>
        </section>
      }
      @if (entryData && !isObjectEmpty(entryData)) {
        <section class="container">
          <entry-page-header />
          <main class="tab-container">
            <mat-tab-group
              #tabs
              (selectedTabChange)="selectTab($event)"
              [selectedIndex]="selectedTab()"
              mat-stretch-tabs="false"
              mat-align-tabs="start"
              >
              <mat-tab label="Summary and Model Confidence">
                <ng-template matTabContent>
                  <summary-tab />
                </ng-template>
              </mat-tab>
              @if (entryData.isComplex === true) {
                <mat-tab >
                  <ng-template mat-tab-label>
                    
                    <div>Macromolecules</div>
                  </ng-template>
                  <ng-template matTabContent>
                    <macromolecules-tab></macromolecules-tab>
                  </ng-template>
                </mat-tab>
              }
              <mat-tab>
                <ng-template mat-tab-label>
                  @if (tedDomainData().length === 0) {
                    <div class="no-data-tag">
                      <div class="na">N/A</div>
                    </div>
                  }
                  <div>Domains</div>
                </ng-template>
                <ng-template matTabContent>
                  <domains-tab></domains-tab>
                </ng-template>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  @if (entryData.isComplex === true) {
                    <div class="no-data-tag">
                      <div class="na">N/A</div>
                    </div>
                  }
                  <div>Annotations</div>
                </ng-template>
                <ng-template matTabContent>
                  <annotations-tab  />
                </ng-template>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  @switch (llmAnnotationsChip()) {
                    @case ('loading') {
                      <div class="loading-data-tag" aria-label="Loading text annotations">
                        <svg width="14" height="14" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                          <path d="M12,4a8,8,0,0,1,7.89,6.7A1.53,1.53,0,0,0,21.38,12h0a1.5,1.5,0,0,0,1.48-1.75,11,11,0,0,0-21.72,0A1.5,1.5,0,0,0,2.62,12h0a1.53,1.53,0,0,0,1.49-1.3A8,8,0,0,1,12,4Z" class="loading-data-tag-spinner" stroke="#707372" fill="#707372" />
                        </svg>
                      </div>
                    }
                    @case ('new') {
                      <div class="new-data-tag">
                        <div class="na">New</div>
                      </div>
                    }
                    @default {
                      <div class="no-data-tag">
                        <div class="na">N/A</div>
                      </div>
                    }
                  }
                  <div>Text Annotations (AI)</div>
                </ng-template>
                <ng-template matTabContent>
                  <text-annotations-tab></text-annotations-tab>
                </ng-template>
              </mat-tab>
              <mat-tab>
                <ng-template mat-tab-label>
                  @if (entryData.isComplex === true) {
                    <div class="no-data-tag">
                      <div class="na">N/A</div>
                    </div>
                  }
                  <div>Similar Proteins</div>
                </ng-template>
                <ng-template matTabContent>
                  @if (isEntryDataAvailable) {
                    <similar-structures-tab [accession]="accession" [afdb_accession]="afdb_accession" [uniprotAccession]="uniprotAccession" />
                  }
                </ng-template>
              </mat-tab>
            </mat-tab-group>
          </main>
          <entry-page-footer [isEntryPage]="true" />
        </section>
      }
      @if (entryData && isObjectEmpty(entryData) && !isShowError()) {
        <section class="container">
          <div style="text-align: center; margin: 90px 0">
            <img src="../../assets/img/loader.gif" width="64" height="64" />
          </div>
        </section>
      }
    </div>
  }
  @if (isMobile) {
    <div class="mobile-view">
      @if(currentMobileView() === MobileView.Overview){
        <overview-mobile> </overview-mobile>
        } @if(currentMobileView() === MobileView.Molstar){
        <molstar-mobile> </molstar-mobile>
      }
    </div>
  }
  <div id="parent-molstar-container" #molstarParent>
    <div id="molstar-element" class="molstar-viewer" #molstarViewer></div>
  </div>
